module.exports = __webpack_public_path__ + "static/media/checklist.eea0ab54.svg";